<div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="p-24 mt-40">
        <div fxLayout="row" fxLayoutAlign="start end">
            <!-- <div>
                <mat-icon class="unselectable" *ngIf="!Content || Content?.Type === 'DriveFolder'" [style.color]="Content?.Color">folder</mat-icon>
                <mat-icon class="unselectable" *ngIf="Content?.Type === 'DriveFile'">{{ Content?.IconName }}</mat-icon>
            </div> -->
            <div class="dms-info-title font-size-22">
                {{ Content?.Name}}
            </div>
        </div>
        <div>
            <button mat-icon-button (click)="Actions.CloseSideNav()">
                <mat-icon class="unselectable">close</mat-icon>
            </button>
        </div>
    </div>
    <!-- <div fxLayout="row" fxLayoutAlign="space-around center" class="tab-container">
        <div class="tab" (click)="Actions.SelectDetailsTab();">
            <div [class]="SelectedTab === 'Details' ? 'tab-title-selected unselectable' : 'tab-title unselectable'">
                Details
            </div>
            <div [class]="SelectedTab === 'Details' ? 'tab-bottom-selected unselectable' : 'tab-bottom unselectable'">
            </div>
        </div>
        <div class="tab" (click)="Actions.SelectActivityTab();" style="pointer-events: none;">
            <div [class]="SelectedTab === 'Activity' ? 'tab-title-selected unselectable' : 'tab-title unselectable'">
                Activity
            </div>
            <div [class]="SelectedTab === 'Activity' ? 'tab-bottom-selected unselectable' : 'tab-bottom unselectable'">
            </div>
        </div>
    </div> -->
    <div class="tab-content">
        <!--{{Document | json}}-->
        <app-details-tab
            *ngIf="SelectedTab === 'Details'"
            [detailsConfig]="dmsConfig?.detailsTab"
            [poweruser]="false"
        ></app-details-tab>
        <app-activity-tab *ngIf="SelectedTab === 'Activity'"></app-activity-tab>
    </div>
</div>
